



























































































































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import HubspotService from '@services/HubspotService'
import Validator from '@utils/validator'

settings =
  vue:
    store: ['member']
    data: ->
      formErrors: {}
      isSubmiting: false
      social_presence:
        market_type: null
        email: null
        password: null
        password_confirmation: null
        first_name: null
        last_name: null
        role: null
        title: null
      top_org:
        organization_type: 'brand'
        organization_name: null
        uniqid: null
      tos:
        sponsor_terms_of_service: accepted: false
        supplier_terms_of_service: accepted: false

    computed:
      hasFormErrors: -> !!@compact(Object.values(@formErrors)).length
      emailError: -> Validator.emailHasError @social_presence.email
      isBrandRep: -> @social_presence.market_type is 'buyer'
      isOrganizer: -> @social_presence.market_type is 'supplier'

      tagsForBrandRep: ->
        [
          'Expand market share'
          'Reach your ideal customer'
          'Elevate your brand recognition'
          'Generate Buzz & Drive sales'
          'Gain insights from direct feedback'
        ]

      tagsForOrganizer: ->
        [
          'Enhance attendee experiences'
          'Partner with top Brands'
          'Organize Events'
          'Manage Venues'
          'Fund your events/venues'
        ]

      hasMinChars: -> @social_presence.password?.length >= 8
      hasUppercaseChar: -> /[A-Z]/.test @social_presence.password || ''
      hasLowercaseChar: -> /[a-z]/.test @social_presence.password || ''
      hasNumberOrSpecialChar: -> /[0-9!@#$&*]/.test @social_presence.password || ''
      confirmationPasswordMatches: -> @social_presence.password and @social_presence.password is @social_presence.password_confirmation

      canSubmit: ->
        [
          @hasMinChars
          @hasUppercaseChar
          @hasLowercaseChar
          @hasNumberOrSpecialChar
          @confirmationPasswordMatches
        ].every(Boolean)

    created: ->
      @navigateToDashboard() if @isLoggedIn()

    mounted: () ->
      @social_presence.market_type = @$route.query.market_type if @$route.query.market_type
      @social_presence.email = @$route.query.email if @$route.query.email

    methods:
      hiSelectMarketType: (marketType) ->
        @social_presence.market_type = marketType
        setTimeout(() =>
          @scrollContainerTo 'html', '.form-register', 100
        , 300)

      hiClearFormErrors: ->
        @formErrors = {}

      clearFormErrorKey: (key) ->
        @formErrors ||= {}
        @formErrors[key] = null

      validateForm: ->
        errors = {}
        errors.email = 'Email is not valid' unless Validator.isEmailValid @social_presence.email
        errors.password = 'Password is not valid' unless Validator.isPasswordValid @social_presence.password
        errors.password_confirmation = 'Passwords don\'t match' unless @social_presence.password is @social_presence.password_confirmation
        @formErrors = errors

      signupClicked: () ->
        @validateForm()
        return if @hasFormErrors

        @isSubmiting = true
        @formErrors = {}
        payload = { @social_presence, @top_org, @tos }
        @tos.sponsor_terms_of_service.accepted = @social_presence.market_type is 'buyer'
        @tos.supplier_terms_of_service.accepted = @social_presence.market_type is 'supplier'
        try
          response = await RecessAPI.signup @social_presence.market_type, payload
          @formErrors = response.errors if response.errors?
          if !response.errors?
            HubspotService.submitHubspotForm(@social_presence.email, @$route)
            @setCurrentMember(response.item)
            window.location.href = '/' # @navigateToDashboard() # reactivity doesnt work after register
          else
            console.log @formErrors, " " + response.errors?.market_type + " "+ response.errors?.token
        catch err 
          console.log err
        finally
          @isSubmiting = false

export default VueOptions.vue settings
